module.exports = __webpack_public_path__ + "static/media/LI14.39398b5c.jpg";